import React, { createContext, useContext, useEffect, useState } from "react";
import API from "../api/api"; // axios setup with interceptors

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check if user is logged in on mount
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      fetchProfile();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchProfile = async () => {
    try {
      const res = await API.get("/api/users/me"); // ✅ uses the new endpoint
      setUser(res.data.data);
    } catch (err) {
      console.error("Failed to fetch profile", err);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  // Login
  const login = async (user_name, password) => {
    try {
      const res = await API.post(
        "/api/auth/login",
        { user_name, password },
        { withCredentials: true }
      );
      console.log(res.data);

      localStorage.setItem("accessToken", res.data.accessToken);
      await fetchProfile();
      return {
        success: true,
        link: res.data.data.role === "admin" ? "/dashboard" : "/dist/dashboard",
      };
    } catch (err) {
      return {
        success: false,
        error: err.response?.data?.error || "Login failed",
      };
    }
  };

  // Logout
  const logout = async () => {
    try {
      await API.post("/api/auth/logout", {}, { withCredentials: true });
    } catch (err) {
      console.error(err);
    } finally {
      localStorage.removeItem("accessToken");
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
